<template>
  <div id="Failure">
    <div class="failure-container">
      <img class="failed-logo" src="../../images/failed.svg" alt="">
      <h1 class="failed-title">{{ $t('RESULT.PAYMENT_FAILURE') }}</h1>
      <h2 class="failed-guide">{{ $t('RESULT.PAYMENT_FAILURE_GUIDE') }}</h2>
      <div class="failed-text">
        <h3>{{ GET_ERROR_MSG.message }}</h3>
        <h3>({{ GET_ERROR_MSG.code }})</h3>
      </div>
      <button class="retry" @click="retryPayment">{{ $t('COMMON.CONFIRM') }}</button>
    </div>
  </div>
</template>

<script>
import vuex from 'vuex';

export default {
  computed: {
    ...vuex.mapGetters({
      'GET_ERROR_MSG': 'GET_ERROR_MSG',
      'GET_PAYMENT_INFORMATION': 'GET_PAYMENT_INFORMATION',
      'GET_REDIRECT': 'GET_REDIRECT'
    })
  },
  created() {
    this.errorCheck()
  },
  methods: {
    retryPayment() {
      // let url = this.GET_REDIRECT.failure;
      let url = this.GET_PAYMENT_INFORMATION.payload.error_url;
      
      location.replace(url)
      // location.href = url;
    },
    errorCheck() {
      if(this.GET_ERROR_MSG.code == '404') {
        try {
          parent.mcancel();
        } catch (error) { }

        try {
          opener.mcancel();
        } catch (error) { }

        try {
          parent.goResult();
        } catch (error) { }
        
        try {
          opener.goResult();          
        } catch (error) { }
      }
    }
  }
}
</script>

<style lang="scss">
#Failure {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: 10px;  

  .failure-container {
    height: 100%;
    border-radius: 18px;
    background: linear-gradient(to bottom, #777, #424242 );

    text-align: center;

    .failed-logo {
      margin-top: 80px;
    }

    .failed-title {
      height: 40px;
      margin-top: 4px;

      font-size: 30px;
      color: white;

      line-height: 1.33;
    }

    .failed-guide {
      height: 30px;
      margin-top: 15px;

      font-size: 20px;
      color: white;

      line-height: 1.5;
    }

    .failed-text {
      margin-top: 5px;

      font-size: 13px;
      color: #b3b3b3;

      line-height: 1.54;
    }

    .retry {
      width: 300px;
      height: 60px;
      margin-top: 48px;

      border-radius: 100px;
      font-size: 20px;
      color: white;
      background-color: #333;

      line-height: 1.5;

      &:active {
        background-color: #666;
      }
    }
  }
}
</style>